import { makeObservable, observable, action, computed } from "mobx"

import { getUserInfo } from "utils/api";

// 头部store
export default class LoginStore {
  user = {};

  constructor() {
    makeObservable(this, {
      user: observable,
      isLogin: computed,
      authorities: computed,
      getUserInfo: action
    });
  }

  get isLogin() {
    return this.user && this.user.pin;
  }

  get authorities() {
    return this.user.authorities || '';
  }

  get userName() {
    return  this.user.nickName ||  this.user.pin || '';
  }

  async getUserInfo() {
    const res = await getUserInfo();
    if(res.data.success) {
        this.user = {
          nickName:res.data?.result?.nickName,
          pin: res.data.result.pin,
          authorities: 'user'
        };
    }
  }
}